import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import noop from 'lodash/noop';
import { FormattedMessage } from 'react-intl';
import { FontFamily } from '@zocdoc/components/src/typography';
import { Modal, ModalContent } from '@zocdoc/components/src/modal';
import { white, navy } from '@zocdoc/branding/colors';
import { Button, STYLE } from '@zocdoc/components/src/button';
import { withCustomMetrics } from '@zocdoc/frontend-metrics';
import {
    GA_EVENT_ACTIONS,
    MOBILE_MESSAGES,
    MOBILE_IMAGES,
    LOCALIZED_STRINGS,
} from './constants';
import Confetti from './assets/confetti-mobile.svg';

class MobileJanuaryWellnessView extends Component {
    static propTypes = {
        onCancelModal: PropTypes.func,
        procedureId: PropTypes.string.isRequired,
        sendMetric: PropTypes.func,
        loggedIn: PropTypes.bool,
        showModal: PropTypes.bool,
    };

    static defaultProps = {
        sendMetric: noop,
        loggedIn: true,
        onCancelModal: noop,
        showModal: true,
    };

    render() {
        const {
            showModal,
        } = this.props;

        if (!showModal) {
            return null;
        }

        return (
            <Content
                data-test="january-wellness-mobile-view"
                onClickCancel={this.handleOnClickCancel}
            >
                {this.renderWellGuideHeader()}
                {this.renderWellGuideDescription()}
                {this.renderWellGuideIcon()}
                {this.renderWellGuideButtons()}
            </Content>
        );
    }

    renderWellGuideHeader() {
        return (
            <Header data-test="january-wellness-mobile-header">
                <FormattedMessage {...LOCALIZED_STRINGS.MobileHeaderTitle} />
            </Header>
        );
    }

    renderWellGuideDescription() {
        const { procedureId } = this.props;
        const { description } = MOBILE_MESSAGES[procedureId];

        return (
            <Description data-test="january-wellness-mobile-description">
                <FormattedMessage {...description} />
            </Description>
        );
    }

    renderWellGuideIcon() {
        const { procedureId } = this.props;

        const image = MOBILE_IMAGES[procedureId];
        const label = MOBILE_MESSAGES[procedureId].type;

        return (
            <IconContainer>
                <Icon image={image} />
                <IconLabel data-test="january-wellness-mobile-icon-label">
                    <FormattedMessage {...label} />
                </IconLabel>
            </IconContainer>
        );
    }

    maybeRenderWellnessGuideButton() {
        const {
            loggedIn,
            procedureId,
        } = this.props;

        if (loggedIn) {
            return (
                <ViewWellnessGuideButton
                    data-test="january-wellness-mobile-wellness-button"
                    href={`/mywellguide?pina_home_januarywellness=clickwellguidebutton_${procedureId}`}
                    style={STYLE.SECONDARY}
                >
                    <FormattedMessage {...LOCALIZED_STRINGS.ViewWellnessGuideButton} />
                </ViewWellnessGuideButton>
            );
        }

        return null;
    }

    renderWellGuideButtons() {
        const { procedureId } = this.props;
        const text = MOBILE_MESSAGES[procedureId].buttonText;

        return (
            <ButtonContainer>
                <BookButton
                    data-test="january-wellness-mobile-book-button"
                    href={`/search?reason_visit=${procedureId}&pina_home_januarywellness=clickbookbutton_${procedureId}`}
                >
                    <FormattedMessage {...text} />
                </BookButton>
                {this.maybeRenderWellnessGuideButton()}
            </ButtonContainer>
        );
    }

    handleOnClickCancel = () => {
        const {
            onCancelModal,
            sendMetric,
            procedureId,
        } = this.props;

        sendMetric({
            action: GA_EVENT_ACTIONS.CLICK_CANCEL_BUTTON,
            eventDetails: {
                ProcedureId: procedureId,
            },
        });

        onCancelModal();
    };
}

const Content = styled(Modal)`
    margin-top: 6px;
    display: flex;
    flex-direction: column;
    width: 100%;
    color: ${navy};
    background-color: ${white};

    ${ModalContent} {
        background-image: url(${Confetti});
        background-repeat: no-repeat;
        background-position-y: 0;
        background-size: contain;
    }
`;

const Header = styled.h1`
    font: 22px/26px ${FontFamily.SharpSansBold};
    text-align: center;
    margin-bottom: 7px;
`;

const Description = styled.p`
    font: 15px/21px ${FontFamily.SharpSansMedium};
    text-align: center;
    margin-bottom: 15px;
`;

const IconContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 23px;
`;

const Icon = styled.div`
    height: 48px;
    width: 48px;
    border-radius: 24px;
    background: url(${p => p.image}) center no-repeat;
    margin-bottom: 5px;
    background-color: ${navy};
`;

const IconLabel = styled.h2`
    font: 15px/21px ${FontFamily.SharpSansBold};
    text-align: center;
`;

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
`;

const FixedButton = styled(Button)`
    display: flex;
    flex-direction: auto;
    align-items: center;

    span {
        margin: auto;
    }
`;

const BookButton = styled(FixedButton)`
    height: 42px;
    font: 15px ${FontFamily.SharpSansSemibold};
    flex: 1;
`;

const ViewWellnessGuideButton = styled(FixedButton)`
    height: 42px;
    font: 15px ${FontFamily.SharpSansSemibold};
    margin-left: 10px;
    flex: 1;
`;

const MobileJanuaryWellnessWithMetrics = withCustomMetrics()(MobileJanuaryWellnessView);

export {
    MobileJanuaryWellnessWithMetrics as default,
    MobileJanuaryWellnessWithMetrics as MobileJanuaryWellnessView,
};
